import { gql, useQuery } from '@apollo/client';

import { BatchBillingServiceContractsSettings } from '@work4all/models/lib/Classes/BatchBillingServiceContractsSettings.entity';

const GET_SERVICE_CONTRACTS_BILLING_SETTING = gql`
  query GetBatchBillingServiceContractsSettings {
    getBatchBillingServiceContractsSettings {
      batchBillingRunName
      headerShowBatchBillingRunName
      headerShowObjectName
      headerShowPeriod
      headerShowContractNumber
      internalNoteShowBatchBillingRunName
      internalNoteShowObjectName
      internalNoteShowPeriod
      internalNoteShowContractNumber
      useDefaultTextFromCustomer
      paymentTypeSource
      setNewBillingDate
      considerQuantity
      dividePriceByQuantity
      divideByRhythm
      multiplyWithRhythm
      purchasePriceFromArticle
      headerShowContractTypeAlias
      internalNoteShowContractTypeAlias
    }
  }
`;

export const useBatchBillingServiceContractsSettings =
  (): BatchBillingServiceContractsSettings => {
    const response = useQuery(GET_SERVICE_CONTRACTS_BILLING_SETTING);
    return response?.data?.getBatchBillingServiceContractsSettings;
  };
